module.exports = __webpack_public_path__ + "img/reviewed.8643b8a2.png";